import { useCallback } from 'react';

import { useChargePriceTypes } from './useChargePriceTypes';

export const useGetChargePriceType = () => {
  const chargePriceTypes = useChargePriceTypes();

  const getChargePriceType = useCallback((chargePriceTypeId: number) => (
    chargePriceTypes.find(item => item.value === chargePriceTypeId)
  ), [chargePriceTypes]);

  return getChargePriceType;
};
